export default __webpack_public_path__ + "static/media/YOOZ-SCAN2PAY-BANNER.1e4ef577.png";